import { registerComponent } from "helpers";

registerComponent(
  "brands-navigation",
  class BrandsNavigation extends HTMLElement {
    constructor() {
      super();

      this.items = this.querySelectorAll(".brands__navigation-item");

      this.items.forEach((item) => {
        item.addEventListener("click", this.onItemClick.bind(this));
      });
    }

    onItemClick(event) {
      const sectionId = event.currentTarget.getAttribute("href");
      const targetSectionPos = document.querySelector(sectionId).offsetTop;

      event.preventDefault();

      window.scrollTo({
        top: targetSectionPos,
        behavior: "smooth",
      });
    }
  },
);
